import { Create } from "react-admin";
import NormativeForm from "./NormativeForm";

const NormativeCreate = () => (
    <Create>
        <NormativeForm />
    </Create>
);

export default NormativeCreate;